module.exports = __webpack_public_path__ + "static/alfonsin-menem-mn.f4518b3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/alfonsin-menem-mn.jpg
// module id = 47
// module chunks = 179383180837082 198383264562098 243549854766872